<template>
  <div
    :class="lightModeActive ? 'bg-verylightpink' : ''"
    class="min-w-64 d-flex flex-column align-items-center"
  >
    <div class="flex-grow-1">
      <button class="mdc-icon-button study-drawer-toggler mgt-8 d-flex">
        <i class="material-icons t-color-whiteHigh mgt-0 font-26">
          menu
        </i>
      </button>
    </div>
    <div class="mgb-16  d-flex flex-column align-items-center">
      <i
        :class="showModal ? 't-color-whiteHigh' : 't-color-whiteDisabled'"
        class="material-icons mgt-0 cursor-pointer font-26"
        tabindex="0"
        @click="compilerActivate"
        @keypress="compilerActivate"
      >
        info
      </i>
      <div class="mgb-18 bg-whiteBorder w-full h-1 mgt-24"></div>
      <i
        :class="
          columViewSelected ? 't-color-whiteHigh' : 't-color-whiteDisabled'
        "
        class="material-icons  mgt-0  mgb-24 cursor-pointer font-26"
        tabindex="0"
        @click="columViewActive()"
        @keypress="columViewActive()"
      >
        view_column
      </i>

      <i
        :class="
          !columViewSelected ? 't-color-whiteHigh' : 't-color-whiteDisabled'
        "
        class="material-icons  mgt-0  cursor-pointer font-26"
        tabindex="0"
        @click="columViewInActive()"
        @keypress="columViewInActive()"
      >
        view_quilt
      </i>

      <div class="mgb-18 bg-whiteBorder w-full h-1 mgt-24"></div>
      <button @click="darkModeToLight()" @keypress="darkModeToLight()">
        <img
          :src="
            lightModeActive
              ? '/img/lightModeFixedButton.png'
              : '/img/darkModeFixedButton.svg'
          "
          alt=""
          class="cursor-pointer w-32 h-32"
        />
      </button>
    </div>

    <div
      :class="lightModeActive ? 'bg-documentGray ' : 'bg-contentPlayerBg'"
      class="study-drawer"
    >
      <div
        class="d-flex justify-content-between align-items-start pdl-24 pdr-16 pdt-27 pdb-27"
      >
        <div class="t-color-white">
          <div class="t-subtitle1 t-color-whiteHigh font-m t-line-h-27">
            {{ lessonName }}
          </div>
        </div>
        <button class="mdc-icon-button mgt--16 mgb--8" tabindex="0">
          <i
            class="material-icons t-color-whiteHigh study-drawer-toggler-close"
          >
            close
          </i>
        </button>
      </div>
      <div class="mgb-18 bg-whiteBorder w-full h-1"></div>
      <div class="scroll-y h-full scrollable-content pdl-20 pdr-20">
        <div class="" v-for="(lesson, index) in lessonsList" :key="lesson.id">
          <div
            class="align-items-center justify-content-between cursor-pointer"
            @click="moveNextLesson(lesson)"
            @keypress="moveNextLesson(lesson)"
          >
            <div class="pdl-10 position-relative pdt-13 pdb-12 active d-flex">
              <div
                :class="{ 'study-list': lesson.id !== lessonId }"
                class="left-content mgr-16 position-relative"
              >
                <i
                  :class="{ show: lesson.rate === 100 }"
                  class="material-icons t-color-saleLine icon-done"
                  >check_circle</i
                >
                <i
                  :class="{ 't-color-whiteHigh': lesson.id === lessonId }"
                  class="material-icons font-20"
                  v-html="lessonTypeCal(lesson)"
                ></i>
                <div class="total">
                  <span
                    :style="{ width: lesson.rate + '%' }"
                    class="real"
                  ></span>
                </div>
              </div>
              <div
                :class="{ 'study-list': lesson.id !== lessonId }"
                class="t-body3 list-content t-line-h-28"
              >
                {{ lesson.name }}
              </div>
            </div>
          </div>
          <div class=" bg-whiteBorder w-full h-1"></div>
        </div>
      </div>
    </div>
    <!-- Popup Start -->
    <div v-if="showModal" class="mdc-dialog d-flex" data-mdc-auto-init="MDCDialog">
      <div class="mdc-dialog__container" style="opacity: 1; transform: scale(1)">
        <div aria-describedby="my-dialog-content" aria-labelledby="my-dialog-title" aria-modal="true" class="mdc-dialog__surface fsf" role="alertdialog" style="max-width: 280px">
          <div id="my-dialog-title" class="mdc-dialog__title t-headline7 font-m l-spacing6 t-line-h-34 pdl-20 pdb-22 t-color-whiteHigh">{{ $t("3740") }}</div>
          <div class="divider"></div>
          <div
            id="my-dialog-content"
            class="mdc-dialog__content pdl-8 pdr-8 pdt-0 pdb-4"
            style="max-height: 246px"
          >
            <ul class="mdc-list mdc-list--avatar-list scroll-y pdb-4">
              <li class="mdc-list-item d-flex justify-content-between w-auto no-selection pdt-11 pdb-11">
                <div class="t-body3 l-spacing48 t-line-h-24 font-r t-color-whiteHigh">
                  {{ $t('3741') }}
                </div>
                <div class="t-nowrap t-right t-body3 t-color-whiteMedium l-spacing48 t-line-h-24">
                  {{ learningLanguage === 'python3' ?  $t('3744') : $t('3743') }}
                </div>
              </li>
              <li class="mdc-list-item d-flex justify-content-between w-auto no-selection pdt-11 pdb-11">
                <div class="t-body3 l-spacing48 t-line-h-24 font-r t-color-whiteHigh">
                  {{ $t('3742') }}
                </div>
                <div class="t-nowrap t-right t-body3 t-color-whiteMedium l-spacing48 t-line-h-24">
                  {{ $t('3745') }}
                </div>
              </li>
            </ul>
          </div>
          <div class="divider"></div>
          <div class="mdc-dialog__actions flex-column pdt-28">
            <div class="d-flex justify-content-end w-full">
              <button
                class="mdc-button mdc-dialog__button"
                data-mdc-dialog-action="discard"
                tabindex="0"
                type="button"
                @click="compilerActivate"
                @keydown="compilerActivate"
              >
                <div class="mdc-button__ripple"></div>
                <span class="mdc-button__label t-color-secondaryBtnText font-r">
                  {{ $t("3746") }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="mdc-dialog__scrim" style="opacity: 1"></div>
    </div>
    <div class="backdrop-study-drawer d-none"></div>
  </div>
</template>

<script>
import learnApi from "@/api/learnApi";
export default {
  name: "leftBar",

  data() {
    return {
      columViewSelected: false,
      lessonId: this.$route.params.lessonId,
      showModal: false
    };
  },

  props: ["lightModeActive", "lessonName", "lessonsList", "learningLanguage"],

  mounted() {
    if (document.querySelectorAll(".content-trigger")) {
      var contentTrigger = Array.from(
        document.querySelectorAll(".content-trigger")
      );
      contentTrigger.forEach(item => {
        item.addEventListener("click", function() {
          if (this.firstChild.innerHTML === "arrow_drop_down") {
            this.firstChild.innerHTML = "arrow_drop_up";
          } else {
            this.firstChild.innerHTML = "arrow_drop_down";
          }
          this.parentNode.nextElementSibling.classList.toggle("d-none");
        });
      });
    }

    if (document.querySelector(".study-drawer-toggler")) {
      var studyDrawerOpen = document.querySelector(".study-drawer-toggler");
      studyDrawerOpen.addEventListener("click", () => {
        document.querySelector(".study-drawer").classList.add("open");
        document
          .querySelector(".backdrop-study-drawer")
          .classList.remove("d-none");
      });
    }

    if (document.querySelector(".study-drawer-toggler-close")) {
      var studyDrawerClose = document.querySelector(
        ".study-drawer-toggler-close"
      );
      studyDrawerClose.addEventListener("click", () => {
        document.querySelector(".study-drawer").classList.remove("open");
        document
          .querySelector(".backdrop-study-drawer")
          .classList.add("d-none");
      });
    }

    if (document.querySelector(".backdrop-study-drawer")) {
      var studyDrawerClose = document.querySelector(".backdrop-study-drawer");
      studyDrawerClose.addEventListener("click", () => {
        document.querySelector(".study-drawer").classList.remove("open");
        document
          .querySelector(".backdrop-study-drawer")
          .classList.add("d-none");
      });
    }
  },

  methods: {
    lessonTypeCal(val) {
      if (val.resourceType.value === "COMPUTER_SCIENCE") {
        return "code";
      } else {
        const valType = val.contentsType.value;
        switch (valType) {
          case "VIDEO":
            return "play_circle";
          case "PDF":
            return "picture_as_pdf";
          case "HTML":
            return "description";
          case "INTERACTIVE_HTML":
            return "description";
          case "SLIDE":
            return "description";
          case "EXAM_PAPER":
            return "calculate";
          case "LIVE_SESSION":
            return "videocam";
          default:
            return "description";
        }
      }
    },

    moveNextLesson(lesson) {
      if (lesson.status.value === "OPENED") {
        if (this.lessonId === lesson.id) {
        } else {
          if (lesson.contentsType.value === "EXAM_PAPER") {
            this.$router.push({
              name: "LessonExamIntro",
              params: {
                learnId: this.$route.params.learnId,
                examineeId: lesson.examineeId
              },
              query: this.$route.query
            });
          } else if (
            lesson.contentsType &&
            lesson.contentsType.value === "LIVE_SESSION"
          ) {
            let params = {
              learnId: this.$route.params.learnId,
              progressionId: lesson.progressionId
            };
            learnApi
              .learnLessonContents(params)
              .then(response => {
                let liveSessionTrueFalse =
                  response.data.data.liveSession.canParticipate;
                if (liveSessionTrueFalse === false) {
                  this.$alert({
                    title: this.$t("3434"), // 학습을 중단한 강의입니다.
                    content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
                    accept: this.$t("3436") // 확인
                  })
                    .then(() => {})
                    .catch(() => {});
                } else {
                  let responseData = response.data.data;
                  let liveSessionData = responseData;
                  this.zoomMeeting(lesson, liveSessionData);
                }
              })
              .catch(err => {});
          } else {
            this.$emit("serverStop", lesson);
          }
        }
      } else {
        this.$alert({
          content:
            '<div id="slidePopup" >' +
            this.$t("1885") +
            "<br/>" +
            this.$t("1886") +
            "</div>",
          accept: this.$t("1887")
        }).then(() => {});
      }
    },

    darkModeToLight() {
      this.$emit("darkModeToLight");
    },

    columViewInActive() {
      this.$emit("columViewActive", false);
      this.columViewSelected = false;
    },

    columViewActive() {
      this.$emit("columViewActive", true);
      this.columViewSelected = true;
    },

    compilerActivate() {
      this.showModal = !this.showModal;
    }
  }
};
</script>

<style scoped>
.list-content {
  color: var(--WhiteMedium);
}
[data-theme="dark"] .mdc-dialog .mdc-dialog__surface{
  background-color: var(--ContentsDarkmodeAppbar) !important;
}

</style>
